export default __webpack_public_path__ + "static/media/arrow-up.e17ce1ca.svg";